/**
 * Normalizes a URL to ensure it's valid and has a protocol.
 * Returns a special invalid URL with encoded information if normalization fails.
 *
 * @param url - The URL string to normalize
 * @returns Normalized URL string or special invalid URL with encoded original
 */
export function normalizeUrl(url: string | undefined | null): string {
  if (!url || typeof url !== 'string') {
    return 'invalid-url';
  }

  const trimmedUrl = url.trim();

  if (trimmedUrl.length === 0) {
    return 'invalid-url';
  }

  try {
    if (trimmedUrl.match(/^[a-zA-Z][a-zA-Z0-9+.-]*:/)) {
      const urlObj = new URL(trimmedUrl);
      return urlObj.href;
    }

    if (trimmedUrl.match(/^[a-zA-Z0-9][a-zA-Z0-9.-]*\.[a-zA-Z]{2,}/)) {
      const urlObj = new URL(`https://${trimmedUrl}`);
      return urlObj.href;
    }

    const encodedOriginal = encodeURIComponent(trimmedUrl.substring(0, 100));
    return `invalid-url;original=${encodedOriginal}`;
  } catch (error) {
    const encodedOriginal = encodeURIComponent(trimmedUrl.substring(0, 100));
    return `invalid-url;original=${encodedOriginal}`;
  }
}
